import { ApiList } from './type';

const apiList: ApiList = {
  outerEmailLogin: 'POST /api/user/v1/login',
  innerLarkLogin: 'POST /api/user/v1/corp-login',
  logout: 'POST /api/user/v1/logout',
  resetPasswordByToken: 'POST /api/user/v1/reset-password-by-token',

  // 基础接口
  getChangePwdEmailCode: 'POST /api/user/v1/send-code',
  updatePwd: 'POST /api/user/v1/update-password',
  getMyAuth: 'POST /api/user/v1/my-auth',

  /* 用户 */
  getUsers: 'GET /api/user/v1/list',
  // getCurrentUser: 'GET /api/user/v1/me',
  getUserById: 'GET /api/user/v1/detail',
  updateUserStatus: 'POST /api/user/v1/status', // 启用、禁用
  resetUserPassword: 'POST /api/user/v1/reset-password',
  addOuterUser: 'POST /api/user/v1/add', // 添加外部用户
  updateOuterUser: 'POST /api/user/v1/edit-outer',
  deleteUsers: 'POST /api/user/v1/delete',
  getUserUserGroups: 'GET /api/user/v1/user-group-list',
  getRolesByUserId: 'GET /api/role/v1/list-all',
  bindUserToRoles: 'POST /api/user/v1/bind-roles',

  /* 用户组 */
  getUserGroups: 'GET /api/user-group/v1/list',
  getUserGroupById: 'GET /api/user-group/v1/detail',
  updateUserGroupStatus: 'POST /api/user-group/v1/status',
  addUserGroup: 'POST /api/user-group/v1/add',
  updateUserGroup: 'POST /api/user-group/v1/edit',
  deleteUserGroups: 'POST /api/user-group/v1/delete',
  getUsersByGroupId: 'GET /api/user-group/v1/user-list',
  bindUserToUserGroup: 'POST /api/user-group/v1/bind-user',
  copyUserGroup: 'POST /api/user-group/v1/copy',
  getUserGroupRoles: 'GET /api/user-group/v1/role-list',
  bindRolesToUserGroup: 'POST /api/user-group/v1/bind-roles',
  unbindRolesFromUserGroup: 'POST /api/user-group/v1/unbind-roles',

  /* 角色 */
  getRoles: 'GET /api/role/v1/list',
  addRole: 'POST /api/role/v1/create',
  copyRole: 'POST /api/role/v1/copy',
  deleteRolesByIds: 'POST /api/role/v1/delete',
  getRoleById: 'GET /api/role/v1/detail',
  updateRoleStatus: 'POST /api/role/v1/status',
  roleBindUsers: 'POST /api/role/v1/bind-user',
  roleBindUserGroups: 'POST /api/role/v1/bind-user-group',
  unbindUsersFromRole: 'POST /api/role/v1/unbind-user',
  unbindUserGroupsFromRole: 'POST /api/role/v1/unbind-user-group',
  updateRole: 'POST /api/role/v1/update',
  bindMenusToRole: 'POST /api/role/v1/bind', // 角色绑定菜单权限
  getUsersByRoleId: 'GET /api/role/v1/list-user',
  getUserGroupsByRoleId: 'GET /api/role/v1/list-user-group',
  getMenuTree: 'GET /api/menu/v1/list-menu',
  getRoleTree: 'GET /api/role/v1/list-all',
  // 应用角色树
  getAppRolesTree: 'GET /api/resource/v1/menu-list',
  // 数据角色树
  getDataRolesTree: 'GET /api/resource/v1/data-policy-list',
  // 角色授权
  grantRole: 'POST /api/resource/v1/grant',

  /**
   * 角色组
   */
  getRolesGroups: 'POST /api/role-group/v1/list',
  addRoleGroups: 'POST /api/role-group/v1/create',
  updateRoleGroups: 'POST /api/role-group/v1/update',
  roleGroupsBindUser: 'POST /api/role-group/v1/bind-user',
  roleGroupsBIndUserGroup: 'POST /api/role-group/v1/bind-user-group',
  roleGroupsUnbindUser: 'POST /api/role-group/v1/unbind-user',
  roleGroupsUnbindUserGroup: 'POST /api/role-group/v1/unbind-user-group',
  roleGroupsBindUserGroupList: 'POST /api/role-group/v1/user-group-list',
  roleGroupsBindUserList: 'POST /api/role-group/v1/user-list',
  deleteRoleGroups: 'POST /api/role-group/v1/delete',

  /* 项目 */
  getUserProjects: 'GET /api/project/v1/user-projects', // 用户所属项目
  getProjectList: 'GET /api/project/v1/list',
  getProjectById: 'GET /api/project/v1/info',
  addProject: 'POST /api/project/v1/new',
  updateProject: 'PUT /api/project/v1/modify',
  deleteProjectById: 'DELETE /api/project/v1/remove',
  getApplicationsByProject: 'GET /api/project/v1/list/applications',
  bindProjectToApplication: 'POST /api/project/v1/bind/applications',
  unbindProjectFromApplication: 'POST /api/project/v1/unbind/applications',
  getUserProject: 'GET /api/project/v1/user-projects',
  getProjectAdmins: 'GET /api/partial-admin/v1/list',
  addAdminsToProject: 'POST /api/partial-admin/v1/add',
  deleteAdminsFromProject: 'DELETE /api/partial-admin/v1/remove',
  updateProjectStatus: 'POST /api/project/v1/status',
  getRolesTreeFromProject: 'GET /api/project/v1/project-roles', // 项目绑定的角色树

  // 项目数据管理员
  getProjectDataManagers: 'GET /api/project-admin/v1/list',
  saveDataManager: 'POST /api/project-admin/v1/save',

  // 用户组
  getProjectUserGroups: 'GET /api/project/v1/project-user-groups',
  bindUserGroupsToProject: 'POST /api/project/v1/user-group-bind-role',
  unbindUserGroupsFromProject: 'DELETE /api/project/v1/project-user-group',
  getProjectUserGroupRoles: 'GET /api/project/v1/project-user-group-role',
  // updateProjectUserGroupAuth: 'POST /api/project/v1/TODO:',
  // 用户
  getProjectUsers: 'GET /api/project/v1/project-users',
  bindUsersToProject: 'POST /api/project/v1/user-bind-role',
  unbindUsersFromProject: 'DELETE /api/project/v1/project-user',
  getProjectUserRoles: 'GET /api/project/v1/project-user-role',
  // updateProjectUserAuth: 'POST /api/project/v1/TODO:',
  // 应用
  getProjectApps: 'GET /api/project/v1/list/applications',
  bindAppsToProject: 'POST /api/project/v1/bind/applications',
  unbindAppsFromProject: 'POST /api/project/v1/unbind/applications',
  updateAppStatus: 'POST /api/application/v1/status',

  /* 应用 */
  getAppList: 'GET /api/application/v1/list',
  getAppDetail: 'GET /api/application/v1/info',
  createApp: 'POST /api/application/v1/new',
  updateApp: 'PUT /api/application/v1/modify',
  deleteApp: 'DELETE /api/application/v1/remove',
  getAppSecret: 'GET /api/application/v1/secret',
  resetAppSecret: 'PUT /api/application/v1/reset-secret',
  getAppProjects: 'GET /api/application/v1/list/projects',
  unbindAppAndProjects: 'POST /api/application/v1/unbind/projects',
  bindAppAndProjects: 'POST /api/application/v1/bind/projects',

  // 工具箱
  addToolAppApi: 'POST /api/tool-app/v1/add',
  deleteToolAppApi: 'POST /api/tool-app/v1/delete',
  getToolAppDetailApi: 'GET /api/tool-app/v1/detail',
  editToolAppApi: 'POST /api/tool-app/v1/edit',
  getToolAppTreeApi: 'GET /api/tool-app/v1/tree',
  reportToolAppLogApi: 'POST /api/tool-app/v1/use-log',
  addToolGroupApi: 'POST /api/tool-group/v1/add',
  deleteToolGroupApi: 'POST /api/tool-group/v1/delete',
  editToolGroupApi: 'POST /api/tool-group/v1/edit',
  getToolGroupListApi: 'GET /api/tool-group/v1/list',
  sortToolGroupApi: 'POST /api/tool-group/v1/sort',

  // 驾驶舱
  getDashboardListApi: 'GET /api/cockpit/dashboard',
  getReportDetailApi: 'POST /api/cockpit/report-query',
  getNewestDateApi: 'GET /api/cockpit/data-newest-date',
  getFakeAIContentApi: 'GET /api/cockpit/dashboard-summary',

  // 驾驶舱推送
  getLarkAllChatsApi: 'GET /api/user/v1/list',
  getPushTaskListApi: 'GET /api/cockpit/push/task-list',
  getPushLogListApi: 'GET /api/cockpit/push/log-list',
  submitPushApi: 'POST /api/cockpit/push',
  retryPushApi: 'POST /api/cockpit/push/retry',
  rollbackPushApi: 'POST /api/cockpit/push/rollback',

  // 飞书审批流列表
  getLarkApprovalListApi: 'GET /partner/lark/v1/toolbox-approval-list',
  submitLarkApprovalApi: 'POST /partner/lark/v1/toolbox-submit-approval',

  /* common */
  getOptionsByType: 'GET /api/common/v1/option-list',
  getAllApisRequest: 'GET /api/menu/v1/list-api',
};

export default apiList;
